import { Link, useNavigate } from "react-router-dom";
import copy from "../../../../assets/images/copy-icon.svg";
import update from "../../../../assets/images/update.svg";
import del from "../../../../assets/images/del.svg";
import EntriesSelection from "../../../../components/pagination/EntriesSelection";
import Pagination from "../../../../components/pagination/Pagination";
import Search from "../../../../components/search/Search";
import { useState } from "react";
import { AddInternalForm } from "../../../../components/modals/AddInternalForm";
import { api } from "../../../../helpers/apiHelper/requestHelper";
import { toastify } from "../../../../helpers/toast/toastify";
import { useEffect } from "react";
import { AlertModal } from "../../../../components/modals/AlertModal";
import { setInternalForms } from "../../../../redux/internalForms/formsSlice";
import { useDispatch } from "react-redux";
import { setLoading } from "../../../../redux/loader/loadingSlice";
import { setSidebar } from "../../../../helpers/sidebar/setSidebar";

export default function InternalForm() {
    const [openAddModal, setOpenAddModal] = useState(false);
    const [forms, setForms] = useState([]);
    const [form, setForm] = useState();
    const [show, setShow] = useState(false);
    const [filtered, setFiltered] = useState([]);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const dispatch = useDispatch();

    useEffect(() => {
        setFiltered(forms);
    }, [forms]);

    useEffect(() => {
        setSidebar("Internal Form");
        populateData();
    }, []);

    const populateData = async () => {
        const response = await api("get", "forms/index");

        if (response?.status) {
            setForms(response?.data);
            dispatch(setInternalForms(response?.data?.reverse()));
        } else {
            toastify(response?.message);
        }
    };

    const handleDelete = (data) => {
        setShow(true);
        setForm(data);
    };

    const confirmAction = async () => {
        dispatch(setLoading(true));
        const response = await api("post", "forms/delete", {
            id: form?._id,
        });
        dispatch(setLoading(false));
        console.log({ response });
        if (response?.data?.status) {
            toastify("Internal Form Deleted Successfully.", "success");
            populateData();
        } else {
            toastify(response?.message, "error");
        }
        setShow(false);
        setForm();
    };

    return (
        <>
            {openAddModal === true && (
                <AddInternalForm
                    setModalClick={() => setOpenAddModal(!openAddModal)}
                    populateData={populateData}
                    form={form}
                    setForm={setForm}
                />
            )}
            {show && (
                <AlertModal
                    confirmAction={confirmAction}
                    setModalClick={() => setShow(false)}
                    confirmBtn={true}
                    modalTitle={[
                        <h2>
                            Do you really want to delete {form?.name || "N/A"}
                            <br /> Form permanently?
                        </h2>,
                    ]}
                    modalDescription={[]}
                />
            )}
            <h4 className="flex flex-wrap mini-title">Internal Forms</h4>
            <Search
                userSearch={true}
                filedText="Search Form"
                teamDropdown={false}
                filters={false}
                addButton={false}
                modalButton={true}
                modalButtonText="Add Form"
                setModalClick={() => setOpenAddModal(!openAddModal)}
                setForms={setFiltered}
                forms={forms}
                component={"Forms"}
            />
            <div className="responsive-table last-child-table w-100">
                <table className="table">
                    <thead>
                        <tr
                            className="no-shadow"
                            style={{ background: "#f6f6f6" }}
                        >
                            <td colSpan="6" height="16"></td>
                        </tr>
                        <tr>
                            <th>Name</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filtered
                            ?.slice(count * page - count, count * page)
                            .map((data, index) => {
                                return (
                                    <>
                                        <tr className="no-shadow">
                                            <td colSpan="6" height="16"></td>
                                        </tr>
                                        <tr key={index}>
                                            <td>{data?.name}</td>
                                            <td>
                                                <span
                                                    className={`status ${
                                                        data.isActive
                                                            ? "active"
                                                            : "nonactive"
                                                    }`}
                                                >
                                                    {data.isActive
                                                        ? "Active"
                                                        : "Inactive"}
                                                </span>
                                            </td>
                                            <td>
                                                <div className="flex items-center">
                                                    <div
                                                        onClick={() => {
                                                            setForm(data);
                                                            setOpenAddModal(
                                                                true
                                                            );
                                                        }}
                                                        className="table-action update cursor-pointer"
                                                    >
                                                        <img
                                                            src={update}
                                                            alt="update"
                                                        />
                                                        <span>
                                                            <small>
                                                                Update
                                                            </small>
                                                        </span>
                                                    </div>
                                                    {/* <div className="table-action copy cursor-pointer">
                                                        <img
                                                            src={copy}
                                                            alt="copy"
                                                        />
                                                        <span>
                                                            <small>Copy</small>
                                                        </span>
                                                    </div> */}
                                                    <div
                                                        className="table-action del cursor-pointer"
                                                        onClick={() =>
                                                            handleDelete(data)
                                                        }
                                                    >
                                                        <img
                                                            src={del}
                                                            alt="del"
                                                        />
                                                        <span>
                                                            <small>
                                                                Delete
                                                            </small>
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </>
                                );
                            })}
                    </tbody>
                </table>
                <div className="flex pagination-combine">
                    <EntriesSelection
                        setCount={setCount}
                        page={page}
                        count={count}
                        data={filtered}
                    />
                    <Pagination
                        count={count}
                        data={filtered}
                        setPage={setPage}
                        page={page}
                    />
                </div>
            </div>
        </>
    );
}
